<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>每日交易管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="账户">
				<el-select v-model="formInline.accountNo" placeholder="选择账户" clearable>
					<el-option :label="item.accountName" :value="item.accountNo" v-for="(item,key) in allTransactionAccounts"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="交易日期">
					<el-date-picker v-model="formInline.maintenanceDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(501)">新增</el-button>
				<el-button size="small" type="warning" @click="drawImg">画图</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-search" @click="updateBondHold" v-if="jurisdiction.includes(331)" >更新数据</el-button> -->
				<el-form-item>
				<el-upload
				:action=url
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:on-preview="handlePreview"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				multiple
				:limit="limitUpload"
				:on-exceed="handleExceed"
				:with-credentials="true"
				:headers="headers"
				:file-list="fileList">
				<el-button  type="danger" @click="handlePreview"  v-if="jurisdiction.includes(321)">导入</el-button>
				</el-upload>
				
			</el-form-item>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
            <el-table-column prop="accountName" label="账户名称" width="150" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.accountName}}</div>
					<div>{{scope.row.accountNo}}</div>
                </template>
			</el-table-column>
            <el-table-column prop="maintenanceDate" label="日期" width="100" align="center"></el-table-column>
			<el-table-column prop="endAmount" label="期末权益" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceHold" label="持仓盈亏" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceClose" label="平仓盈亏" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceCloseSum" label="累计平仓盈亏" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceRedeem" label="赎回" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceOut" label="出金" width="100" align="center"></el-table-column>
			<el-table-column prop="endTotalAmount" label="期末权益总额" width="100" align="center"></el-table-column>
			<el-table-column prop="maintenanceIn" label="入金" width="100" align="center"></el-table-column>
			<el-table-column prop="startAmount" label="期初权益" width="100" align="center"></el-table-column>


			<el-table-column prop="maintenanceShare" label="份额" width="100" align="center"></el-table-column>								
			<el-table-column prop="netValue" label="净值" width="100" align="center"></el-table-column>		
			<el-table-column prop="yield" label="收益率" width="100" align="center"></el-table-column>
			<el-table-column prop="days" label="天数" width="100" align="center"></el-table-column>								
			<el-table-column prop="yieldYear" label="年化收益率" width="100" align="center"></el-table-column>		
			<el-table-column prop="volatilityYear" label="年化波动率" width="100" align="center"></el-table-column>
			<el-table-column prop="backRate" label="回撤率" width="100" align="center"></el-table-column>								
			<el-table-column prop="maxBackRate" label="最大回撤率" width="100" align="center"></el-table-column>
			<el-table-column prop="year10rate" label="10年期国债收益率" width="100" align="center"></el-table-column>		

			<el-table-column prop="sharpeRatio" label="夏普比率" width="100" align="center"></el-table-column>
			<el-table-column prop="calmarRatio" label="卡玛比率" width="100" align="center"></el-table-column>
			<el-table-column prop="successRate" label="投资胜率" width="100" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.successRate*100}}%</div>
                </template>
			</el-table-column>


			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;" v-if="jurisdiction.includes(501)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)" v-if="jurisdiction.includes(502)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>


		<div id="mainYield" style="width: 600px; height: 600px;"></div>
		<div id="mainNetValue" style="width: 600px; height: 600px;"></div>
		<div id="mainSharpeRatio" style="width: 600px; height: 600px;"></div>
		<div id="mainMaxBackRate" style="width: 600px; height: 600px;"></div>
		<div id="mainSuccessRate" style="width: 600px; height: 600px;"></div>


		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form :rules="rules" :model="editForm">
				<el-form-item label="账户名称：" label-width="140px">
					<el-input v-model="editForm.accountName"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="账户账号：" label-width="140px">
					<el-input v-model="editForm.accountNo"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="期末权益：" label-width="140px">
					<el-input v-model="editForm.endAmount"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="持仓盈亏：" label-width="140px">
					<el-input v-model="editForm.maintenanceHold"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="平仓盈亏：" label-width="140px">
					<el-input v-model="editForm.maintenanceClose"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="账户账号：" label-width="140px">
				<el-input v-model="editForm.accountNo"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="期初金额：" label-width="140px">
				<el-input v-model="editForm.startAmount"  style="width:200px"></el-input>
				</el-form-item>

				<el-form-item label="变动金额：" label-width="140px">
				<el-input v-model="editForm.maintenanceAmount"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="日期：" label-width="140px">
					<el-date-picker v-model="editForm.maintenanceDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
                </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="addEdit" >设置</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	let echarts = require('echarts/lib/echarts')
	require('echarts/lib/chart/line')
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require("echarts/lib/component/legend");
	require("echarts/lib/component/grid");
	require("echarts/lib/component/toolbox");

	import {
		getTransactionAccountLevel1,
		getAllTransactionAccounts,
		addEditTransactionMaintenance,
		delTransactionMaintenance,
		getTransactionMaintenances,
		getTransactionMaintenancesAll

	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				isholdList:[{label:'持仓',value:1},{label:'已出',value:0}],
				transactionAccountLevel1: [],
				allTransactionAccounts:[],
				analysisMap:{},
				listData: [],
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],
				url:localStorage.getItem("baseUrl")+"/manager/transaction/importTransactionMaintenance",

				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',
				dialogVisible: false,
				// 所属分类
				tableData: [],
				value: [],
				editForm: {},
				selectEditForm: {},
				usernames: '',
				allListData:[],
				imgDates:[],
				imgYieldSeries:[],
				imgNetValueSeries:[],
				imgSharpeRatioSeries:[],
				imgMaxBackRateSeries:[],
				imgSuccessRateSeries:[],
			}
		},
		watch: {},
		methods: {
			towNumber(val,len) {
				return parseFloat(val).toFixed(len)    
			},
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.isHold === 1){
				styleJson = { "color": "red" };} 
				return styleJson
			},
			getTransactionAccountLevel1() {
				getTransactionAccountLevel1().then(res => {
					if (res.code == '200') {
						this.transactionAccountLevel1 = res.data
					}
				})
				getAllTransactionAccounts().then(res => {
					if (res.code == '200') {
						this.allTransactionAccounts = res.data
						console.log("this.cityList",this.allTransactionAccounts)
					}
				})
			},
						// 获得数据
			getdata() {
				let param = this.formInline
				getTransactionMaintenances(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},



			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditTransactionMaintenance(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },

			// 删除
			handledelete(row) {
				let msg = '确认删除?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delTransactionMaintenance({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},






			drawImg(){
				this.imgYieldSeries.splice(0,this.imgYieldSeries.length);
				this.imgNetValueSeries.splice(0,this.imgNetValueSeries.length);
				getTransactionMaintenancesAll(this.formInline).then(res => {
					if (res.code == '200') {
						this.allListData=res.data
						console.log("allListData0:")
						console.log("allListData:",this.allListData)
						this.allListData.forEach(item => {
						if (this.imgDates.indexOf(item.maintenanceDate)<0){
							this.imgDates.push(item.maintenanceDate)
						}
						})
						this.imgDates.sort()
						console.log("this.imgDates",this.imgDates)
						this.allTransactionAccounts.forEach(item => {
							var accountNo=item.accountNo
							var imgYieldserie=[]
							var imgNetValueSerie=[]
							var imgSharpeRatioSerie=[]
							var imgMaxBackRateSerie=[]
							var imgSuccessRateSerie=[]

							this.allListData.forEach(item => {
								if (item.accountNo==accountNo){
									imgYieldserie.push({
										date: item.maintenanceDate,
										value: item.yield
									})
									imgNetValueSerie.push({
										date: item.maintenanceDate,
										value: item.netValue
									})
									imgSharpeRatioSerie.push({
										date: item.maintenanceDate,
										value: item.sharpeRatio
									})
									imgMaxBackRateSerie.push({
										date: item.maintenanceDate,
										value: item.maxBackRate
									})
									imgSuccessRateSerie.push({
										date: item.maintenanceDate,
										value: item.successRate
									})
								}
							})
							this.imgYieldSeries.push({name: accountNo,type: "line",stack: "总量",data: imgYieldserie})
							this.imgNetValueSeries.push({name: accountNo,type: "line",stack: "总量",data: imgNetValueSerie})
							this.imgSharpeRatioSeries.push({name: accountNo,type: "line",stack: "总量",data: imgSharpeRatioSerie})
							this.imgMaxBackRateSeries.push({name: accountNo,type: "line",stack: "总量",data: imgMaxBackRateSerie})
							this.imgSuccessRateSeries.push({name: accountNo,type: "line",stack: "总量",data: imgSuccessRateSerie})
						})
						this.drawLine("mainYield",'收益率【%】',this.imgYieldSeries)
						this.drawLine("mainNetValue",'净值',this.imgNetValueSeries)
						this.drawLine("mainSharpeRatio",'夏普比率',this.imgSharpeRatioSeries)
						this.drawLine("mainMaxBackRate",'最大回撤',this.imgMaxBackRateSeries)
						this.drawLine("mainSuccessRate",'胜率【%】',this.imgSuccessRateSeries)
					}
				})
			},

			drawLine(id,title,sers) {
				this.charts = echarts.init(document.getElementById(id));
				this.charts.setOption({
					title: {text: title,left: 'center',top: 20,textStyle: {color: '#000',fontSize: 22}},
					tooltip: {trigger: "axis",},
					legend: {data:this.allTransactionAccounts},
					grid: {left: "6%",right: "4%",bottom: "6%",containLabel: false},
					toolbox: {feature: {saveAsImage: {},},},
					xAxis: {type: "category",boundaryGap: false,data: this.imgDates},
					yAxis: {type: "value"},
					series:sers 
				});
			}


		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getTransactionAccountLevel1()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>